/**
 * Legacy workflows may store an empty PHP array as `[]`; redux-form needs a plain object.
 *
 * @param {unknown} value
 * @returns {Record<string, string>}
 */
export function normalizeBrickInputsMapping(value) {
    if (value == null || typeof value !== 'object' || Array.isArray(value)) {
        return {};
    }
    return { ...value };
}
